import styles from "./Disclaimer.module.scss";
import Pin24PxOutlinedIcon from "@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/Pin24PxOutlined";
import Billing24PxOutlinedIcon from "@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/Billing24PxOutlined";
import EighteenPlus24PxOutlined from "@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/EighteenPlus24PxOutlined";
import TickInCircle24PxOutlined from "@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/TickInCircle24PxOutlined";
import Basket24PxOutlined from "@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/Basket24PxOutlined";
import OpenInNew24PxOutlined from "@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/OpenInNew24PxOutlined";
import { UnderlinedButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";

interface DisclaimerProps {
  disclaimerClickHandler?: () => void;
}
export const Disclaimer = ({ disclaimerClickHandler }: DisclaimerProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.disclaimer} data-testid="disclaimer:introduction">
        John Lewis plc is a credit broker and not a lender. Credit provided by
        Creation.
      </div>

      <div className={styles.section} data-testid="disclaimer:who-can-apply">
        <div className={styles.header}>Who can apply</div>
        <div className={styles.point}>
          <EighteenPlus24PxOutlined />
          18 years or over
        </div>
        <div className={styles.point}>
          <Pin24PxOutlinedIcon />
          UK resident for a minimum of 3 years
        </div>
        <div className={styles.point}>
          <Billing24PxOutlinedIcon />
          Annual income of £10,000 or more*
        </div>
      </div>

      <div className={styles.section} data-testid="disclaimer:how-to-apply">
        <div className={styles.header}>How to apply</div>
        <div className={styles.point}>
          <Basket24PxOutlined />
          Choose your finance option at checkout
        </div>
        <div className={styles.point}>
          <TickInCircle24PxOutlined />
          Complete eligibility process with our provider, Creation
        </div>
      </div>
      <div className={styles.section} data-testid="disclaimer:more-information">
        <div className={styles.findOutMoreGroup}>
          <UnderlinedButton
            tag="a"
            href="https://www.johnlewis.com/our-services/paymentplans"
            target="_blank"
            role="button"
            className={styles.button}
            data-testid="disclaimer:more-information-button"
            onClick={disclaimerClickHandler}
          >
            Find out more about credit
          </UnderlinedButton>
          <OpenInNew24PxOutlined />
        </div>
        <p className={styles.annotation}>
          * We&apos;ll consider joint income if you&apos;re either married,
          living with a partner, in a civil partnership, in receipt of
          Disability Allowance, Employment and Support Allowance, or Personal
          Independence Payment.
        </p>
        <p className={styles.annotation}>
          Please note that the amount displayed is for one item only. Additional
          services are not included.
        </p>
        <p className={styles.annotation}>
          Credit subject to status, UK residents only, 18 and over.
        </p>
      </div>
    </div>
  );
};
